// extracted by mini-css-extract-plugin
module.exports = {"root":"styles_root__3bUjz","colBig":"styles_colBig__HOwF5","colSmall":"styles_colSmall__2MVvN","shopifyNameWrapper":"styles_shopifyNameWrapper__2GBdB"};